import { Asterisk } from "lucide-react";

const brands = ["Booming Bulls", "EIFS", "Knowledge Woods", "Aman Travel", "Mindsweep"];

export const BrandsMarquee = () => (
  <div className="relative overflow-hidden border-y border-slate-100 bg-white py-8" data-testid="brands-marquee">
    <div className="marquee-track flex w-max items-center">
      {[...brands, ...brands].map((brand, i) => (
        <span key={`${brand}-${i}`} className="flex shrink-0 items-center">
          <span className="px-8 font-display text-2xl sm:text-3xl font-semibold tracking-tight text-slate-300 transition-colors duration-300 hover:text-brand-600 sm:px-12">
            {brand}
          </span>
          <Asterisk className="h-5 w-5 shrink-0 text-brand-300" aria-hidden="true" />
        </span>
      ))}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" aria-hidden="true" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" aria-hidden="true" />
  </div>
);
